import { useQuery } from '@tanstack/react-query';
import { useRisClient } from './useRisClient';
import { useAuth } from 'utils/auth';
import useTokenClaims from './useTokenClaims';
import { UserTypeEnum } from 'types/enums/User';

export function useCurrentUser() {
  const { client } = useRisClient();
  const auth = useAuth();
  const isAuthenticated = auth && auth.isAuthenticated && !auth.isLoading;
  const { userType, isLoading: isTokenClaimsLoading } = useTokenClaims();

  const { data } = useQuery({
    queryKey: ['myUser'],
    queryFn: async () => (await client.myUsers.myUsersGetMyUser()).data,
    enabled:
      isAuthenticated &&
      !isTokenClaimsLoading &&
      userType !== UserTypeEnum.DISTRIBUTOR,
    staleTime: 5000,
  });

  return data || undefined;
}
